module.exports = __webpack_public_path__ + "img/a4.6def8528.svg";